module.exports = __webpack_public_path__ + "b706b83ad8e51d72262402bf04c81e91.pdf";